import * as THREE from "three";
import TexturedMesh from "./TexturedMesh";

/**
 * Creates a flat plane with a texture, with a fixed orientation
 */
export default class CylinderSeam extends TexturedMesh {
  /**
   * Creates seam using the included image
   *
   * @param {Player} player
   * @param {Number} offsetRotation - the offset in radians of the baseplate
   * @param {Number{-1, 1}} rotationDirection - the direction that the rotation should take;
   */
  constructor(
    player,
    offsetRotation,
    flip = true,
    rotationDirection = 1,
    height = 800,
  ) {
    // const height = 800;
    // const radius = 599;
    //
    // const geometry = new THREE.CylinderBufferGeometry(
    //     radius,
    //     radius,
    //     height,
    //     64,
    //     1,
    //     true,
    // );
    const geometry = new THREE.PlaneBufferGeometry(110, height);
    super(player, geometry);

    this.loadTexture(
      {
        urls: {
          full: "https://imgix.imgo.theatro360.com/pano-seam.png?w=371",
        },
      },
      flip,
      () => {},
      false,
      false,
    );
    this.material.side = THREE.DoubleSide;
    this.material.transparent = true;
    this.offsetRotation = offsetRotation;
    this.rotationDirection = rotationDirection;
  }

  /**
   * To be called every frame to keep orientation fixed.
   *
   * @param {THREE.Camera} camera
   */
  update(rotation) {
    // this.rotation.z = this.rotationDirection * (rotation - this.offsetRotation);
  }
}
